import React from "react";
import { Link } from "react-router-dom";

export const Logo = ({ size = 32, withWord = true, className = "" }) => {
  return (
    <Link
      to="/"
      data-testid="brand-logo"
      className={`inline-flex items-center gap-3 ${className}`}
      aria-label="Velacin home"
    >
      <span
        className="grid place-items-center rounded-[10px] font-extrabold text-white shadow-lg"
        style={{
          width: size,
          height: size,
          fontSize: size * 0.55,
          background: "linear-gradient(135deg, #4C6EF5 0%, #002FA7 100%)",
          boxShadow: "0 6px 20px -6px rgba(76,110,245,0.6)",
        }}
      >
        V
      </span>
      {withWord && (
        <span className="text-lg font-bold tracking-tight text-white">
          Velacin
        </span>
      )}
    </Link>
  );
};

export default Logo;
